import type { Action } from './map-engine.js';
import type { MapImage } from '../types/app.js';
import { cloneMapImage } from './map-image.js';

export type MapImageAction = Extract<Action, { type: 'add_image' | 'update_image' | 'delete_image' }>;

export function isMapImageAction(action: { type: string }): action is MapImageAction {
  return action.type === 'add_image' || action.type === 'update_image' || action.type === 'delete_image';
}

export function applyMapImageAction(images: MapImage[], action: MapImageAction): MapImage[] {
  if (action.type === 'add_image') return [...images.map(cloneMapImage), cloneMapImage(action.image)];
  if (action.type === 'update_image') {
    return images.map((image) => image.id === action.after.id ? cloneMapImage(action.after) : cloneMapImage(image));
  }
  return images.filter((image) => image.id !== action.image.id).map(cloneMapImage);
}

export function revertMapImageAction(images: MapImage[], action: MapImageAction): MapImage[] {
  if (action.type === 'add_image') return images.filter((image) => image.id !== action.image.id).map(cloneMapImage);
  if (action.type === 'update_image') {
    return images.map((image) => image.id === action.before.id ? cloneMapImage(action.before) : cloneMapImage(image));
  }
  const restored = images.map(cloneMapImage);
  restored.splice(Math.max(0, Math.min(action.index, restored.length)), 0, cloneMapImage(action.image));
  return restored;
}
